import React from "react";
import { motion } from "framer-motion";
export default function Intro() {
  return (
    <>
      <section className="hero">
        <div className="hero__bg">
          <img
            src={process.env.PUBLIC_URL + "/images/sisvip/sis-hero-bg.png"}
            alt="hero"
          />
        </div>
        <div className="auto__container">
          <div className="hero__inner">
            <motion.div
              animate={{
                opacity: [0, 1],
              }}
              transition={{ duration: 0.7, ease: "easeOut" }}
            >
              <div className="hero-container">
                <div className="hero-meta">
                  <div className="sis-logo">
                    <img
                      className="img-fluid"
                      src={
                        process.env.PUBLIC_URL +
                        "/images/sisvip/sis-2026-logo-white.png"
                      }
                    />
                  </div>
                  <div className="hero-meta-date league-spartan-font bold">
                    ATLANTA <span className="separator">|</span> JUNE 2-3, 2026
                  </div>
                </div>
                <h1 className="hero-title league-spartan-font extra-bold">
                  JOIN SIS 2026
                  <br />
                  VIP EVENTS SERIES
                </h1>
                <div className="hero-btns">
                  <div className="hero-btn">
                    <a
                      href="#apply"
                      type="button"
                      className="pink-btn no-grad simple inter-font"
                      onClick={(e) => {
                        e.preventDefault();
                        const scrollToApply = () => {
                          const el = document.getElementById("apply");
                          if (el) {
                            el.scrollIntoView({ behavior: "smooth" });
                            return true;
                          }
                          return false;
                        };

                        if (!scrollToApply()) {
                          let attempts = 0;
                          const interval = setInterval(() => {
                            attempts++;
                            if (scrollToApply() || attempts > 30) {
                              clearInterval(interval);
                            }
                          }, 100);
                        }
                      }}
                    >
                      SCROLL DOWN TO APPLY
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <div className="container narrower" style={{ marginTop: "60px" }}>
        <div className="cap-width">
          <div className="row hero-row-lower">
            <div className="col-12 col-md-6">
              <motion.div
                animate={{
                  x: [-200, 0],
                  opacity: [0, 1],
                }}
                transition={{ duration: 1.2, ease: "easeOut" }}
              >
                <div className="header-img">
                  <img
                    className="img-fluid"
                    src={
                      process.env.PUBLIC_URL +
                      "/images/sisvip/landmark-events-collage.png"
                    }
                    alt="landmark-events"
                  />
                </div>
              </motion.div>
            </div>
            <div className="col-12 col-md-6">
              <motion.div
                animate={{
                  x: [50, 0],
                  opacity: [0, 1],
                }}
                transition={{ duration: 1.2, ease: "easeOut" }}
              >
                <div className="header-text-container">
                  <div className="header-text">
                    We’re excited to welcome you to{" "}
                    <b>Social Innovation Summit 2026</b> this June in Atlanta
                    gathering 1,250+ bold thinkers and purpose-driven
                    leaders, all committed to building what’s next. As part of
                    your experience, we’re thrilled to extend an exclusive
                    invitation to our <b>VIP event series</b> – a collection of
                    intimate, themed lunches and dinners designed to spark real
                    connection, candid conversation, and meaningful
                    collaboration.
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
